import moment, { Moment } from 'moment';

export interface WorkFreeDay {
    dateFrom: string;
    dateTo: string;
}

/**
 * Delivery date rule, identical to the regular order date picker (PdfPreviewOrderPopup):
 * not before today + 21 days (end of that day), not more than a year ahead,
 * and not inside any work-free period from the CMS holiday calendar.
 */
export function isDeliveryDateDisabled(current: Moment | null | undefined, workFreeDays: WorkFreeDay[]): boolean {
    if (!current) {
        return false;
    }

    const today = moment().startOf('day');
    const earliest = moment().add(21, 'days').endOf('day');
    const latest = moment().add(1, 'year').endOf('day');

    const isWorkFreeDay = (workFreeDays ?? []).some((day) => {
        const start = moment(day.dateFrom).startOf('day');
        const end = moment(day.dateTo).endOf('day');
        return current.isSameOrAfter(start) && current.isSameOrBefore(end);
    });

    return current.isBefore(today) || current.isBefore(earliest) || current.isAfter(latest) || isWorkFreeDay;
}

/** First date the delivery picker lets the user choose (today + 22 days, skipping work-free days). */
export function getFirstAvailableDeliveryDate(workFreeDays: WorkFreeDay[]): Moment {
    const candidate = moment().add(22, 'days').startOf('day');
    for (let i = 0; i < 366; i++) {
        if (!isDeliveryDateDisabled(candidate, workFreeDays)) {
            return candidate.clone();
        }
        candidate.add(1, 'day');
    }
    return moment().add(22, 'days').startOf('day');
}